import { DateTime } from 'luxon';

export class GanttZone
{
    constructor (public since: DateTime, public until: DateTime, public label: string, public width: number)
    {
    }
}
